module.exports = __webpack_public_path__ + "static/media/fb-logo.fbcd72d0.svg";